import React from "react";

const WarningRound = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.9422 26.225H6.05779C2.98798 26.225 1.62483 23.712 3.15581 21.0069L12.1062 4.56579C13.6611 1.88891 16.3785 1.84206 17.9035 4.58033L26.8419 21.0028C28.3734 23.7174 27.0153 26.225 23.9422 26.225ZM14.1 9.37498V18.2031C14.1 18.7002 14.5029 19.1031 15 19.1031C15.497 19.1031 15.9 18.7002 15.9 18.2031V9.37498C15.9 8.87792 15.497 8.47498 15 8.47498C14.5029 8.47498 14.1 8.87792 14.1 9.37498ZM16.0562 21.85C16.0562 22.4333 15.5833 22.9062 15 22.9062C14.4166 22.9062 13.9437 22.4333 13.9437 21.85C13.9437 21.2666 14.4166 20.7937 15 20.7937C15.5833 20.7937 16.0562 21.2666 16.0562 21.85Z"
        fill="#333333"
      />
      <mask
        id="mask0"
        maskType="alpha"
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="26"
        height="25"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.9422 26.225H6.05779C2.98798 26.225 1.62483 23.712 3.15581 21.0069L12.1062 4.56579C13.6611 1.88891 16.3785 1.84206 17.9035 4.58033L26.8419 21.0028C28.3734 23.7174 27.0153 26.225 23.9422 26.225ZM14.1 9.37498V18.2031C14.1 18.7002 14.5029 19.1031 15 19.1031C15.497 19.1031 15.9 18.7002 15.9 18.2031V9.37498C15.9 8.87792 15.497 8.47498 15 8.47498C14.5029 8.47498 14.1 8.87792 14.1 9.37498ZM16.0562 21.85C16.0562 22.4333 15.5833 22.9062 15 22.9062C14.4166 22.9062 13.9437 22.4333 13.9437 21.85C13.9437 21.2666 14.4166 20.7937 15 20.7937C15.5833 20.7937 16.0562 21.2666 16.0562 21.85Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <rect width="30" height="30" fill="white" />
      </g>
    </svg>
  );
};

export default WarningRound;
